/**
 * Switch — on/off control for settings rows, the web counterpart of the
 * mobile AppSwitch.
 */
import './switch.css';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Required when the visible label is not tied to the control by id. */
  label: string;
  labelledBy?: string;
  describedBy?: string;
  disabled?: boolean;
}

export function Switch({
  checked,
  onChange,
  label,
  labelledBy,
  describedBy,
  disabled = false,
}: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={labelledBy ? undefined : label}
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      disabled={disabled}
      className={`ui-switch${checked ? ' ui-switch--on' : ''}`}
      onClick={() => onChange(!checked)}
    >
      <span className="ui-switch__thumb" aria-hidden />
    </button>
  );
}
